import { render, staticRenderFns } from "./edit-entity-button.vue?vue&type=template&id=36006844&scoped=true"
import script from "./edit-entity-button.vue?vue&type=script&lang=js"
export * from "./edit-entity-button.vue?vue&type=script&lang=js"
import style0 from "./edit-entity-button.vue?vue&type=style&index=0&id=36006844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36006844",
  null
  
)

export default component.exports